import {
  EventFieldFilter,
  FilterOperation,
  EventField,
} from "../../generated/weblinkTypes";
import {
  startOfDayWithTimeZone,
  endOfDayWithTimeZone,
  getDateTimeForStartWeek,
  getDateTimeForEndWeek,
} from "../../utils/dateTimeHelpers";
import { BookerIntention } from "../Order/BookingPage";
import { CatalogFilter } from "./CatalogFilterContext";

export const buildEventFilters = (
  catalogFilters: CatalogFilter,
  timeZoneName: string,
  excludeEventIds: string[],
  bookerIntention: BookerIntention,
): EventFieldFilter[] => {
  const filters = [];
  if (bookerIntention === BookerIntention.Self && excludeEventIds.length) {
    filters.push({
      field: EventField.Id,
      operation: FilterOperation.Notin,
      values: excludeEventIds,
    });
  }
  if (catalogFilters.learners) {
    filters.push({
      value: catalogFilters.learners,
      operation: FilterOperation.Ge,
      field: EventField.RemainingPlaces,
    });
  }
  if (catalogFilters.learningMode) {
    filters.push({
      value: catalogFilters.learningMode,
      operation: FilterOperation.Eq,
      field: EventField.DeliveryMethod,
    });
  }
  if (catalogFilters.fromDate) {
    filters.push({
      value: startOfDayWithTimeZone(catalogFilters.fromDate, timeZoneName),
      operation: FilterOperation.Ge,
      field: EventField.Start,
    });
    if (catalogFilters.toDate) {
      filters.push({
        value: endOfDayWithTimeZone(catalogFilters.toDate, timeZoneName),
        operation: FilterOperation.Le,
        field: EventField.End,
      });
    }
  }
  if (catalogFilters.fromWeek && catalogFilters.year) {
    filters.push({
      value: getDateTimeForStartWeek(
        catalogFilters.fromWeek,
        catalogFilters.year,
        timeZoneName,
      ),
      operation: FilterOperation.Ge,
      field: EventField.Start,
    });
  }
  if (catalogFilters.toWeek && catalogFilters.year) {
    filters.push({
      value: getDateTimeForEndWeek(
        catalogFilters.toWeek,
        catalogFilters.year,
        timeZoneName,
      ),
      operation: FilterOperation.Le,
      field: EventField.End,
    });
  }
  if (catalogFilters.location) {
    // Private Events can hold an ad-hoc Location typed into the Event, which
    // has no Location record to match on an ID. `locationName` resolves both
    // that and a real Location, so it is what the filter compares.
    filters.push({
      value: catalogFilters.location.name,
      operation: FilterOperation.Eq,
      field: EventField.LocationName,
    });
  }
  if (catalogFilters.course) {
    filters.push({
      value: catalogFilters.course.code,
      operation: FilterOperation.Eq,
      field: EventField.CourseCode,
    });
  }
  if (catalogFilters.search) {
    filters.push({
      value: `%${catalogFilters.search}%`,
      operation: FilterOperation.Like,
      field: EventField.Name,
    });
  }

  return filters;
};
